import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  descricaoStatusDocumento,
  DocumentStatusEnum,
} from 'src/app/api/module/erp/shared/enumerable/documento-status-enum';

@Component({
  selector: 'app-documento-card-list',
  templateUrl: './documento-card-list.component.html',
  styleUrls: ['./documento-card-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentoCardListComponent implements OnInit, AfterViewInit {
  constructor() {}
  @Input() titulo!: string;
  @Input() imagemSrc!: string;
  @Input() status!: string;
  @Input() tipoDocumento!: any;
  @Input() descricao!: any;
  @Input() groupDocument: number = 0;
  @Input() documentProposalId!: string;
  @Input() filePath!: string;
  @Input() idOrigem!: string;
  @Input() dataUrl!: string;
  @Input() heColaborador: boolean = false;
  @Output() abrirModal = new EventEmitter<[any, any, any, any, any, any, any, string]>();
  @Output() onClick = new EventEmitter<void>();

  documentoStatus = DocumentStatusEnum;

  ngOnInit(): void {}
  onCardClick() {
    if (this.heColaborador) {
      this.onClick.emit(); // Emite o evento de visualização
    } else {
      this.abrirModal.emit([
        this.tipoDocumento,
        this.titulo,
        this.descricao,
        this.documentProposalId,
        this.filePath,
        this.groupDocument,
        this.idOrigem,
        this.dataUrl,
      ]);
    }
  }
  getDescricaoStatus(status: DocumentStatusEnum): string {
    return descricaoStatusDocumento[status] || 'Status desconhecido';
  }

  ngAfterViewInit(): void {}
}
